import { forceListingStore } from '~/modules/stores/listings/forceListingStore';
import { getTechnologyStore, listingStore, selectListing, selectListingType } from '~/modules/stores/listings/listingStore';
import { getSolutionId, getTemplateId } from '~/modules/utilities/solutionUtilities';
export async function obtainSolutionAndTrialTemplateIds() {
  // cache the store states because we're about to update their state before running validations
  const listingStateSnapshot = listingStore.getState();

  // Solutions and Trial Templates only apply to force listings
  if (getTechnologyStore() !== forceListingStore) {
    return {
      listing: selectListing(listingStore.getState()),
      setListingId: id => {
        listingStateSnapshot.listing.id = id;
      },
      resetState: () => undefined // noop
    };
  }
  const storeWithSolutionsStateSnapshot = getTechnologyStore().getState();

  // modify internal state by inserting solution ids if appropriate into their respective plugins / extensions
  await Promise.all([getTemplateId().then(id => id && listingStore.setTrialTemplateSolutionId(id)), getSolutionId(selectListingType(listingStore.getState())).then(id => id && getTechnologyStore().setSolutionId(id))]);

  // extract the newly updated data model
  const listing = selectListing(listingStore.getState());
  return {
    listing,
    setListingId: id => {
      listingStateSnapshot.listing.id = id;
    },
    resetState: () => {
      // reset stores to previous state
      listingStore.setState(listingStateSnapshot, true);
      getTechnologyStore().setState(storeWithSolutionsStateSnapshot, true);
    }
  };
}
export function moveItem(indexTarget, indexToChange, items) {
  //This moves the indexToChange element after the indexTargetElement on the array
  items.splice(indexTarget, 0, items.splice(indexToChange, 1)[0]);
}

//Should only be called from the store and from a set function
export function removeEmptyContentItems(contentItems) {
  for (let i = contentItems.length - 1; i >= 0; i--) {
    var _contentItems$i;
    const item = (_contentItems$i = contentItems[i]) === null || _contentItems$i === void 0 ? void 0 : _contentItems$i.data;
    if (!(item !== null && item !== void 0 && item.title) || !item.mediaId && !item.url) {
      contentItems.splice(i, 1);
    }
  }
}

/**
 * Filters out empty/undefined properties from the SupportInformation Plugin.
 * The idea it sanitizing the info before it is sended to oAF to validation/saving.
 *
 * @param supportInfo The SupportInformation plugin to be cleaned.
 * @returns The filtered and cleaned support info object. it always contain a businessEmail property.
 *
 */
export function cleanSupportInfoData(supportInfo) {
  const filteredSupportInfo = Object.fromEntries(Object.entries(supportInfo).filter(([_key, value]) => typeof value === 'boolean' || !!value));
  return {
    ...filteredSupportInfo,
    ...{
      businessEmail: supportInfo.businessEmail ? supportInfo.businessEmail : ''
    }
  };
}

// Should return true for Listings created in Tz.
export function isLegacyListing(listing) {
  return (listing === null || listing === void 0 ? void 0 : listing.external_id) != null && !validateUUID(listing.external_id);
}

// The following logic is copied from 'uuid' source code: https://github.com/uuidjs/uuid
export function validateUUID(uuid) {
  return typeof uuid === 'string' && /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i.test(uuid);
}
export function isNotUrl(url) {
  const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9]+(?:[-.][a-z0-9]+)*\.[a-z]{2,6}(?:\/[^\s]*)?(?:\?[^\s]*)?$/i;
  const protocolRegex = /^(?:(?:https?|ftp):\/\/)$/;
  return !(urlRegex.test(url) || protocolRegex.test(url));
}
export function getDefaultProvisionFlowByExtensionType(extensionType) {
  switch (extensionType) {
    case 'force/package':
    case 'force/bolt':
    case 'force/flow':
    case 'force/lightning':
    case 'force/copilot':
    case 'quip/package':
      return {
        provisionFlow: 'Package'
      };
    case 'b2c-commerce/package':
    case 'salesforce-platform/api':
    case 'b2c-commerce/api':
    case 'marketing-cloud/api':
      return {
        provisionFlow: 'External'
      };
    case 'tableau/accelerator':
      return {};
    default:
      //Should never enter in this case
      throw new Error(`The extension Type received it is not valid: ${extensionType}`);
  }
}